function DashboardActiveFooter({isGameRunning, userData, udpFeedStatus}) {
    return (
        <footer className="h-8 border-t border-[#233648] bg-[#0a0c10] px-6 flex items-center justify-between shrink-0">
            <div className="flex gap-4">
                <div className="flex items-center gap-1.5">
                    <div className={`${udpFeedStatus ? "bg-acc-green" : " bg-acc-red"} size-1.5 rounded-full`}></div>
                    <span className="text-[10px] font-bold text-[#92adc9] uppercase">UDP Feed: {udpFeedStatus ? "Stable (10Hz)" : "Not Active"}</span>
                </div>
                <div className="flex items-center gap-1.5">
                    <div className={`${isGameRunning ? "bg-acc-green" : "bg-acc-red"} size-1.5 rounded-full`}></div>
                    <span className="text-[10px] font-bold text-[#92adc9] uppercase">Sim: {isGameRunning ? "Running" : "Not Running"}</span>
                </div>
                <div className="flex items-center gap-1.5 ml-2 border-l border-[#233648] pl-4">
                    <span className="material-symbols-outlined text-[12px] text-acc-cyan">router</span>
                    <span className="text-[10px] font-bold text-[#92adc9] uppercase">Connection: Global Relay</span>
                </div>
            </div>
            <div className="flex items-center gap-2 text-[10px] font-bold text-[#92adc9]">
                <span>CLIENT VERSION {userData["client-version"] !== null ? userData["client-version"] : "Unknown"}</span>
            </div>
        </footer>
    );
}

export default DashboardActiveFooter;